export default __webpack_public_path__ + "static/media/BlueSplash2.f961e659.png";